// src/components/PrivateRoute.tsx
import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/?signin=1" replace />;
  }

  // Authenticated but waitlisted users cannot enter the app —
  // send them back to the landing where the Beta Gate Card is shown.
  if (user?.access_tier === "waitlisted") {
    return <Navigate to="/" replace />;
  }

  return children as ReactElement;
};

export default PrivateRoute;
